// export const baseUrl = 'http://localhost:3000/api/v1/'
// export const baseUrl = "http://localhost:3011/api/v1/"
export const baseUrl = "https://api.mapskil.com/api/v1/"
// export const baseUrl = "http://192.168.0.50:3000/api/v1/"
// export const baseUrl = "https://api.hpedigitalclassroom.com:3000/api/v1/"
// export const baseUrlfile = "http://103.177.225.32:3000/assets/testReport/"

export const url = {
    LANGUAGE_LIST: `${baseUrl}language/list`,
    EXPERT_LEVEL_LIST: `${baseUrl}expertLevel/list`,
    STUDIO_USER_LIST: `${baseUrl}expert/profile/list`,
    STUDIO_USER_CREATE: `${baseUrl}userexpert/create`,
    STUDIO_USER_UPDATE: `${baseUrl}expert/profileUpdate`,
    STUDIO_USER_INFO: `${baseUrl}expert/profile/Info`,
    BOOKING_USER_EXPERT_LIST: `${baseUrl}booking/userexpert/list`,
    PROMO_CONTENT_LIST: `${baseUrl}expert/promotionContent/list`,
    ADMIN_LOGIN: `${baseUrl}admin/login`,
    SLOT_DATE_LIST: `${baseUrl}date/list`,
    SLOT_TIME_LIST: `${baseUrl}slotTime/list`,
    AVAILABLE_TIME_LIST: `${baseUrl}expert/availableTime/list`,
    AVAILABLE_SLOT_CUSTOM_CREATE: `${baseUrl}expert/availableTime/custom/create`,
    AVAILABLE_SLOT_WEEKLY_CREATE: `${baseUrl}expert/availableTime/weekly/create`,
    SEND_BOOKING_MESSAGE: `${baseUrl}booking/sendmessage`,
    DASHBOARD_COUNT_DATA: `${baseUrl}dashboard/count`,
    DASHBOARD_TODAY_BOOKING: `${baseUrl}dashboard/TodayBookings`,
    DASHBOARD_OVERALL_BOOKING: `${baseUrl}dashboard/OverallBookings`,
    DASHBOARD_TODAY_BOOKING_DETAIL: `${baseUrl}dashboard/TodayBookingsDetail`,
}